import type { BotIdTags, FormVariant } from "./types";

import { EventName } from "@homeinstead/shared";
import { trackClickEvent } from "./click-events";
import { getTrackedClickEventBody } from "./tracked-click";

export const ServiceLocationTrackedClickEvent = (
  PostalCode: number,
  OfficeLocation: number,
  page_path: string,
  page_url: string,
  formVariant: FormVariant,
) => ({
  ...getTrackedClickEventBody({
    element_name: "service_location_btn",
    page_path,
    page_url,
  }),
  form_variant: formVariant,
  IsCorporate: false,
  OfficeLocation,
  PostalCode,
});

// TODO: Update Array to accept only CareOption which has shape:
// export type CareOption = keyof CareSeekerLeadFormData["step3"];

// // For multiple selections (one or more)
// export type CareOptionSelection = [CareOption, ...CareOption[]];
export const ServiceTypeTrackedClickEvent = (
  selected_options: Array<string>,
  page_path: string,
  page_url: string,
  formVariant: FormVariant,
) => ({
  ...getTrackedClickEventBody({
    element_name: "service_types_next",
    page_path,
    page_url,
  }),
  form_variant: formVariant,
  IsCorporate: false,
  selected_options,
});

type FormSubmissionResult =
  | "success"
  | "duplicate"
  | "server-error"
  | "validation-error";

// TODO: Update types on selectedOptions and recipient to be more specific
export const ServiceLeadFormSubmitEvent = ({
  franchiseNumber,
  result,
  page_url,
  selectedOptions,
  recipient,
  formVariant,
  tags,
}: {
  franchiseNumber?: string | undefined;
  result: FormSubmissionResult;
  page_url: string;
  selectedOptions?: string[] | undefined;
  recipient?: string | undefined;
  formVariant: FormVariant;
  tags: BotIdTags;
}) => ({
  event: EventName.SERVICE_LEAD_FORM_SUBMIT,
  form_id: "service-lead-form-ppc-restructure",
  form_submission_intent: "service",
  form_submission_result: result,
  form_variant: formVariant,
  franchise_number: franchiseNumber,
  lang: "en",
  page_url,
  recipient,
  selected_options: selectedOptions,
  tags,
});

export const EmployButtonTrackedClickEvent = (
  page_path: string,
  page_url: string,
) => {
  return trackClickEvent("employment_btn", {
    page_path,
    page_url,
  });
};

export const ServiceRecipientTrackedClickEvent = (
  recipient: string,
  page_path: string,
  page_url: string,
  formVariant: FormVariant,
) => ({
  recipient,
  ...getTrackedClickEventBody({
    element_name: "service_recipient",
    page_path,
    page_url,
  }),
  form_variant: formVariant,
  IsCorporate: false,
});

export const ServiceUrgencyTrackedClickEvent = (
  urgency: string,
  page_path: string,
  page_url: string,
  page_zone: string,
  formVariant: FormVariant,
) => ({
  element_name: "service_urgency",
  event: "tracked_click",
  form_variant: formVariant,
  IsCorporate: false,
  lang: "en",
  page_path,
  page_url,
  page_zone,
  urgency,
});
